export const CarrierIssuerAddress = [
    {
        id: 1,
        name: "4th Floor, 35 Great St Helen’s, London, EC3A 6AP"
    },
    {
        id: 2,
        name: "2nd Floor La Vallee House, Upper Dargle Road, Bray, Co. Wicklow, Ireland"
    },    
]